import React from "react";
import Moment from "react-moment";
import {
  formatScrV2DurationDays,
  pickScrV2IdentityFields,
} from "./SCRV2IdentityFields";

export { formatScrV2DurationDays, pickScrV2IdentityFields };

/** Formats a DTO date for display only (no identity math). */
export const renderScrV2IdentityDate = (value) =>
  value ? <Moment format="DD-MM-YYYY">{value}</Moment> : "-";
